import React from "react";
import FastAuth from "./onboarding/fast-auth";

export default function NotLoggedIn() {
  return <FastAuth />;
}
